function getCookieHT(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookieHT(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

if( 'yes' == getCookieHT('cookielawinfo-checkbox-functional') ) {
    document.getElementById('cookie-law-info-bar').remove();
}

window.onload = function() {

    function addParameterToLink(className, paramName, paramValue) {
        var links = document.getElementsByClassName(className);

        for (var i = 0; i < links.length; i++) {
        var link = links[i];
        var currentHref = link.href;

            if (currentHref.indexOf('?') !== -1) {
                link.href = currentHref + '&' + paramName + '=' + paramValue;
            } else {
                link.href = currentHref + '?' + paramName + '=' + paramValue;
            }
        }
    }

    function gclid() {
        let urlParams = new URLSearchParams( encodeURI( window.location.search ) );
        let parameterGclid = urlParams.get('gclid');

        if( parameterGclid ) {
            setCookieHT('parameter-gclid', parameterGclid);
        }
        parameterGclid = getCookieHT('parameter-gclid');
        if( parameterGclid ) {
            addParameterToLink('iframe-form', 'gclid', parameterGclid);
        }
    }
    gclid();

	function salesPortal() {
		let urlParams = new URLSearchParams( encodeURI( window.location.search ) );
		let parameterUser = urlParams.get('sales-agent');

		if( parameterUser ) {
				setCookieHT('parameter-sales-portal-sales-agent', parameterUser);
		}
	}
	salesPortal();

    function quoteId() {
        const urlParams = new URLSearchParams(window.location.search);
        const quoteId = urlParams.get('quote-id');

        if (quoteId) {
            setCookieHT('parameter-quote-id', quoteId);
        }
    }
    quoteId();

}

// setTimeout(() => {

//     if( 'yes' == getCookieHT('cookielawinfo-checkbox-functional') ) {
//         // Hide element with ID cookie-law-info-bar if cookie is set
//         document.getElementById('cookie-law-info-bar').style.display = 'none';
//         document.getElementById('cookie-law-info-bar').remove();
        
//     }

//     // console.log(getCookieHT('cookielawinfo-checkbox-necessary'));
//     // document.getElementById('cookie-law-info-bar').style.display = 'none';

// }, "250");